<template>
  <div class="container-custom" v-if="member">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'ADATA Members',
          to: {
            name: 'ADATAmembers'
          }
        },
        {
          name: 'Member Info',
          to: {
            name: 'AdataMemberInfo',
            params: {
              id: $route.params.id
            }
          }
        }
      ]"
    ></Breadscrumbs>
    <!-- actions -->
    <div class="py-5">
      <h2>ADATA會員資訊</h2>
    </div>

    <!-- Block1 會員資訊 -->
    <div class="block">
      <!-- 名字 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          名字
        </div>
        <div class="flex-grow-1 flex-basis-0">
          {{ member.first_name }}
        </div>
      </div>
      <!-- 姓氏 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          姓氏
        </div>
        <div class="flex-grow-1 flex-basis-0">
          {{ member.last_name }}
        </div>
      </div>
      <!-- 帳號 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          帳號
        </div>
        <div class="flex-grow-1 flex-basis-0">
          {{ member.email }}
        </div>
      </div>
      <!-- 國別/區域 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          國別/區域
        </div>
        <div class="flex-grow-1 flex-basis-0">
          {{ member.country }}
        </div>
      </div>
      <!-- 性別 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          性別
        </div>
        <div class="flex-grow-1 flex-basis-0">{{ member.gender? '男性' : '女性' }}</div>
      </div>
      <!-- 生日 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          生日
        </div>
        <div class="flex-grow-1 flex-basis-0">
          {{ member.birthday }}
        </div>
      </div>
      <!-- 興趣 -->
      <!--<div class="form-item py-5 d-flex">-->
        <!--<div class="w-240px mr-5">-->
          <!--興趣-->
        <!--</div>-->
        <!--<div class="flex-grow-1 flex-basis-0">-->
          <!--<span v-for="(interest, i) in info.interests" :key="`interest-${i}`"-->
            <!--&gt;<span v-if="i != 0">,</span> <span>{{ interest }}</span></span-->
          <!--&gt;-->
        <!--</div>-->
      <!--</div>-->
      <!-- 訂閱電子報 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          訂閱電子報
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <div v-if="member.is_subscription">
            <span class="mr-5">已訂閱</span>
            <button
              class="btn btn-outlined danger-500--text my-n2"
              style="border: 1px solid #f60000"
              @click="toggleSubscribe(member.id)"
            >
              Unsubscribe
            </button>
          </div>
          <div v-else>
            <span class="mr-5">未訂閱</span>
            <button
              class="btn btn-outlined success-500--text my-n2"
              style="border: 1px solid #88c640"
              @click="toggleSubscribe(member.id)"
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>
      <!-- 聯絡電話 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          聯絡電話
        </div>
        <div class="flex-grow-1 flex-basis-0">{{ member.phone }}</div>
      </div>
      <!-- 地址 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          地址
        </div>
        <div class="flex-grow-1 flex-basis-0">
          {{ member.address }}
        </div>
      </div>
      <!-- 重置密碼 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          重置密碼
        </div>
        <div class="flex-grow-1 flex-basis-0 d-flex my-n2">
          <div class="w-248px mr-5">
            <h5 class="mb-1">請先輸入密碼</h5>
            <div class="form-input-group">
              <input type="text" v-model="member.tempPassword" />
            </div>
          </div>
          <div>
            <h5 class="mb-1">輸入密碼後發送</h5>
            <button class="btn btn-primary w-160px" @click="sendHandler">
              發送驗證信
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Block2 註冊產品、報修紀錄 -->
    <div class="table-tabs my-5">
      <div
        class="tab pa-10px"
        :class="{ active: selectedTab === '註冊產品' }"
        @click="selectedTab = '註冊產品'"
      >
        註冊產品
      </div>
      <!--<div-->
        <!--class="tab pa-10px"-->
        <!--:class="{ active: selectedTab === '報修紀錄' }"-->
        <!--@click="selectedTab = '報修紀錄'"-->
      <!--&gt;-->
        <!--報修紀錄-->
      <!--</div>-->
    </div>
    <div>
      <RegisterProducts v-if="selectedTab === '註冊產品'"></RegisterProducts>
      <!--<RecoveryHistory v-if="selectedTab === '報修紀錄'"></RecoveryHistory>-->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import RegisterProducts from '@/views/F-1__ADATAmembers/c/F-1-1__ADATA-member-info_RegisterProducts.vue';

export default {
  components: {
    Breadscrumbs,
    RegisterProducts,
    // RecoveryHistory,
  },
  data: () => ({
    // block2
    selectedTab: '註冊產品', // 註冊產品 維修紀錄
  }),
  async created() {
    if (this.$route.params.id) {
      await this.getMember(this.$route.params.id);
    }
  },
  computed: {
    ...mapState('member', ['member']),
  },
  methods: {
    ...mapActions('notifications', ['info']),
    ...mapActions('member', {
      getMember: 'findById',
      toggleSubscribe: 'toggleSubscribe',
      sendResetPasswordEmail: 'sendResetPasswordEmail',
    }),
    sendHandler() {
      this.sendResetPasswordEmail(this.$route.params.id).then(() => {
        this.info('發送成功');
      });
    },
  },
};
</script>

<style></style>
